/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFormValues, reduxForm } from 'redux-form';
import { useLocation } from 'react-router';
import saga from '../../saga';
import reducer from '../../reducer';
import { useInjectReducer } from '../../../../../utils/injectReducer';
import { useInjectSaga } from '../../../../../utils/injectSaga';
import { CompanySettingsContent } from './components/company-settings-content';
import {
	getCompanySettingInfoSelector,
	getFormInitialCompanySettingValuesSelector,
	getIsCompanySettingLoadingSelector,
} from '../../selectors';
import { FORM_SETTINGS_NAME } from '../../constants';
import { validateSetting } from '../../utils';

const CompanySettingsWrapper = ({
	isCompanySettingInfoLoading,
	companySettingInfo,
	change,
	formValues,
	stages,
	documentTypes,
	isStagesLoading,
	isDocumentsTypesLoading,
}) => {
	useInjectSaga({ key: 'companiesModalSaga', saga });
	useInjectReducer({ key: 'companiesModalReducer', reducer });
	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const mode = query.get('mode');

	const isEditing = mode === 'settings-edit';

	return (
		<CompanySettingsContent
			isCompanySettingInfoLoading={isCompanySettingInfoLoading}
			companySettingInfo={companySettingInfo}
			isEditing={isEditing}
			formValues={formValues}
			change={change}
			stages={stages}
			documentTypes={documentTypes}
			isDocumentsTypesLoading={isDocumentsTypesLoading}
			isStagesLoading={isStagesLoading}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	companySettingInfo: getCompanySettingInfoSelector(),
	isCompanySettingInfoLoading: getIsCompanySettingLoadingSelector(),
	formValues: getFormValues(FORM_SETTINGS_NAME),
	initialValues: getFormInitialCompanySettingValuesSelector(),
});

const mapDispatchToProps = {};

const withForm = reduxForm({
	form: FORM_SETTINGS_NAME,
	enableReinitialize: true,
	onSubmit: validateSetting,
})(connect(mapStateToProps)(CompanySettingsWrapper));

const CompanySettings = connect(mapStateToProps, mapDispatchToProps)(withForm);

CompanySettingsWrapper.propTypes = {
	companySettingInfo: PropTypes.object,
	isCompanySettingInfoLoading: PropTypes.bool.isRequired,
	relationshipSettingHeader: PropTypes.string,
	activeCompanyId: PropTypes.string,
	formValues: getFormValues(FORM_SETTINGS_NAME),
	change: PropTypes.func.isRequired,
	stages: PropTypes.array,
	documentTypes: PropTypes.array,
	isDocumentsTypesLoading: PropTypes.bool.isRequired,
	isStagesLoading: PropTypes.bool.isRequired,
};

export default CompanySettings;
